import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';
import { Typography, Divider, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const NewsContent = ({ content }) => {
    const safe = (content || '').toString().trim();
    const isProbablyHtml = /<\/?[a-z][\s\S]*>/i.test(safe);

    const sanitizedHtml = useMemo(() => {
        if (!isProbablyHtml) return '';
        // Render TipTap/HTML safely (public page). Keep formatting tags; remove scripts/events.
        return DOMPurify.sanitize(safe, {
            USE_PROFILES: { html: true },
        });
    }, [isProbablyHtml, safe]);

    return (
        <>
            {isProbablyHtml ? (
                <Box
                    data-ui="section-news-content"
                    sx={{
                        fontSize: '1.25rem',
                        lineHeight: 1.8,
                        color: '#262626',
                        mb: 6,
                        fontFamily: 'Georgia, serif',

                        '& p': { m: 0, mb: 2.5 },
                        '& h2': { mt: 4, mb: 2, fontSize: '1.65rem', lineHeight: 1.25 },
                        '& h3': { mt: 3, mb: 1.5, fontSize: '1.35rem', lineHeight: 1.3 },
                        '& blockquote': {
                            m: 0,
                            my: 3,
                            pl: 2.5,
                            borderLeft: '3px solid rgba(0,0,0,0.12)',
                            color: 'rgba(0,0,0,0.75)',
                        },
                        '& ul, & ol': { m: 0, mb: 2.5, pl: 4 },
                        '& li': { mb: 1 },
                        '& a': {
                            color: 'inherit',
                            textDecoration: 'underline',
                            textDecorationThickness: '2px',
                            textUnderlineOffset: '3px',
                        },
                        '& a:hover': { color: 'primary.main' },
                        '& strong': { fontWeight: 700 },
                        '& em': { fontStyle: 'italic' },
                    }}
                    dangerouslySetInnerHTML={{
                        __html: sanitizedHtml || '<p>Conteúdo em breve.</p>',
                    }}
                />
            ) : (
                <Typography
                    variant="body1"
                    sx={{
                        fontSize: '1.25rem', // Slightly larger for readability
                        lineHeight: 1.8,
                        color: '#262626', // High contrast
                        whiteSpace: 'pre-line',
                        mb: 6,
                        fontFamily: 'Georgia, serif', // Editorial feel
                    }}
                    data-ui="section-news-content"
                >
                    {safe || 'Conteúdo em breve.'}
                </Typography>
            )}

            <Divider sx={{ mb: 4 }} />

            {/* Use a plain text link (avoid global Button pill styles). */}
            <Box
                component={RouterLink}
                to="/news"
                data-ui="action-back-to-news"
                sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 1,
                    color: 'primary.main',
                    fontWeight: 700,
                    textDecoration: 'none',
                    fontFamily: '"Inter", sans-serif',
                    '&:hover': { textDecoration: 'underline' },
                }}
            >
                <ArrowBackIcon sx={{ fontSize: 20 }} />
                Voltar para Notícias
            </Box>
        </>
    );
};

export default NewsContent;
